import styled from '@emotion/styled'
import Box from '@mui/material/Box'
import TextField from '@mui/material/TextField'
import { arrayOf, string, oneOfType } from 'prop-types'

const StyledField = styled(TextField)`
  margin-top: ${({ margin }) => (margin === 'dense' ? 8 : 16)}px;
  margin-bottom: ${({ margin }) => (margin === 'dense' ? 4 : 8)}px;
`

export const CvsTextField = ({ error = [], ...rest }) => {
  const helperText = (() => {
    if (Array.isArray(error)) {
      return error.map((e, i) => (
        <Box key={i} component="span" display="block">
          {e}
        </Box>
      ))
    }

    return error
  })()

  return (
    <StyledField
      error={Boolean(error.length)}
      helperText={helperText}
      variant="outlined"
      {...rest}
    />
  )
}

CvsTextField.propTypes = {
  error: oneOfType([arrayOf(string), string]),
}
